/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { getUserObjectGetResponseSchema } from './getUserObjectGetResponseSchema.ts';

export const getUserObjectQueryParamsSchema = z.object({
  relative_key: z.string(),
});

/**
 * @description 200 response
 */
export const getUserObject200Schema = z.lazy(() => getUserObjectGetResponseSchema);

/**
 * @description 505 response
 */
export const getUserObject505Schema = z.any();

export const getUserObjectQueryResponseSchema = z.lazy(() => getUserObject200Schema);
